(function() {
  // Initialize all search instances on the page
  function initializeSearchInstances() {
    const searchWrappers = document.querySelectorAll('.animated-search-wrapper');

    searchWrappers.forEach(wrapper => {
      initializeSearchInstance(wrapper);
    });
  }

  // Initialize a single search instance
  function initializeSearchInstance(wrapper) {
    // Guard against double initialization
    if (wrapper.dataset.searchInit === 'true') return;
    wrapper.dataset.searchInit = 'true';

    // Animated Placeholder Configuration - Only last word animates
    const placeholderKeywords = [
      "lip balm",
      "face mask",
      "serums",
      "eyeshadow",
      "moisturizer",
      "sunscreen"
    ];

    const staticText = "Search for ";
    let currentTextIndex = 0;
    let currentCharIndex = 0;
    let isTyping = true;
    let typingTimeout;
    let isInputActive = false;

    // Get elements within this specific instance
    const searchInput = wrapper.querySelector('.animated-search-input');
    const searchClearBtn = wrapper.querySelector('.search-clear-btn');
    const predictiveResults = wrapper.querySelector('.predictive-search-results');
    const predictiveContent = wrapper.querySelector('.predictive-search-content');
    const loadingElement = wrapper.querySelector('.predictive-search-loading');
    const searchSuggestions = wrapper.querySelector('.search-suggestions');
    const suggestionsList = wrapper.querySelector('.suggestions-list');
    const starIcon = wrapper.querySelector('.tsf_star_icon');
    const sectionElement = wrapper.closest('.section-animated-search');

    if (!searchInput) return;

    // Mobile scroll functionality for star icon and sticky header
    // INP FIX: passive listener + requestAnimationFrame + only touch classes when state changes
    if (window.innerWidth <= 749 && sectionElement) {
      let sectionTop = 0;
      let ticking = false;
      let stuck = null;
      let measured = false;

      // Get section top position + reserve its space so content doesn't jump when it goes fixed
      function updateSectionTop() {
        if (!sectionElement || stuck) return;
        sectionTop = sectionElement.offsetTop;
        sectionElement.parentElement.style.minHeight = sectionElement.offsetHeight + 'px';
        measured = true;
      }

      // PERF FIX: measure after first paint (avoids a forced layout during page load)
      requestAnimationFrame(() => setTimeout(updateSectionTop, 0));

      window.addEventListener('scroll', () => {
        if (ticking || !measured) return;
        ticking = true;
        requestAnimationFrame(() => {
          const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
          const on = currentScroll > sectionTop + 50;
          if (on !== stuck) {
            stuck = on;
            if (starIcon) starIcon.classList.toggle('show-on-scroll', on);
            wrapper.classList.toggle('show-star', on);
            sectionElement.classList.toggle('sticky-on-scroll', on);
          }
          ticking = false;
        });
      }, { passive: true });

      // Recalculate section top on window resize
      window.addEventListener('resize', updateSectionTop, { passive: true });
    }

    // Typing Animation - Only animate the last keyword
    function typeText() {
      // INP FIX: pause animation while the tab is hidden
      if (document.hidden) { typingTimeout = setTimeout(typeText, 1000); return; }
      if (isInputActive || searchInput.value.length > 0) {
        return;
      }

      const currentKeyword = placeholderKeywords[currentTextIndex];

      if (isTyping) {
        if (currentCharIndex <= currentKeyword.length) {
          searchInput.placeholder = staticText + currentKeyword.substring(0, currentCharIndex);
          currentCharIndex++;
          typingTimeout = setTimeout(typeText, 100);
        } else {
          isTyping = false;
          typingTimeout = setTimeout(typeText, 2000);
        }
      } else {
        if (currentCharIndex > 0) {
          currentCharIndex--;
          searchInput.placeholder = staticText + currentKeyword.substring(0, currentCharIndex);
          typingTimeout = setTimeout(typeText, 50);
        } else {
          isTyping = true;
          currentTextIndex = (currentTextIndex + 1) % placeholderKeywords.length;
          typingTimeout = setTimeout(typeText, 500);
        }
      }
    }

    // Start typing animation
    typeText();

    // Handle input focus/blur
    searchInput.addEventListener('focus', () => {
      isInputActive = true;
      clearTimeout(typingTimeout);
    });

    searchInput.addEventListener('blur', () => {
      setTimeout(() => {
        if (searchInput.value.length === 0) {
          isInputActive = false;
          currentCharIndex = 0;
          isTyping = true;
          setTimeout(typeText, 1000);
        }
      }, 200);
    });

    // Predictive Search
    let searchTimeout;
    let suggestionTimeout;
    let currentSearchQuery = '';

    searchInput.addEventListener('input', (e) => {
      const query = e.target.value.trim();

      // Show/hide clear button (not on mobile)
      if (window.innerWidth > 320) {
        searchClearBtn.style.display = query.length > 0 ? 'flex' : 'none';
      }

      clearTimeout(searchTimeout);
      clearTimeout(suggestionTimeout);

      if (query.length === 0) {
        predictiveResults.style.display = 'none';
        return;
      }

      if (query.length < 2) {
        predictiveResults.style.display = 'none';
        return;
      }

      // Show loading
      predictiveResults.style.display = 'block';
      loadingElement.style.display = 'flex';
      searchSuggestions.style.display = 'none';
      predictiveContent.style.display = 'none';

      // Get suggestions with slight delay
      suggestionTimeout = setTimeout(() => {
        fetchSuggestions(query);
      }, 200);

      // Get products with longer delay
      searchTimeout = setTimeout(() => {
        performSearch(query);
      }, 300);
    });

    // Clear button functionality
    searchClearBtn.addEventListener('click', () => {
      searchInput.value = '';
      searchInput.focus();
      searchClearBtn.style.display = 'none';
      predictiveResults.style.display = 'none';
    });

    // Fetch dynamic suggestions - Query terms only
    function fetchSuggestions(query) {
      fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=query&resources[limit]=8`)
        .then(response => response.json())
        .then(data => {
          displaySuggestions(data, query);
        })
        .catch(error => {
          console.error('Suggestions error:', error);
        });
    }

    // Helper function to highlight search query in suggestion text
    function highlightQuery(text, query) {
      const regex = new RegExp(`(${query})`, 'gi');
      return text.replace(regex, '<span class="highlight">$1</span>');
    }

    // Display dynamic suggestions - Query terms only with pills style
    function displaySuggestions(data, query) {
      // Get query suggestions if available
      const queries = data.resources.results.queries || [];

      if (queries.length === 0) {
        searchSuggestions.style.display = 'none';
        return;
      }

      let html = '';
      queries.forEach(queryItem => {
        const suggestionText = queryItem.text;
        const suggestionUrl = queryItem.url;
        const highlightedText = highlightQuery(suggestionText, query);

        html += `
          <li
              class="suggestion-item"
              data-query="${suggestionText}"
            >
              <a href="${suggestionUrl}" class="predictive-search__item link link--text" tabindex="-1">
                <div class="predictive-search__item-content">
                  <p
                    class="predictive-search__item-heading"
                    aria-label="${suggestionText}"
                  >
                    ${suggestionText}
                  </p>
                </div>
              </a>
            </li>
        `;
      });

      suggestionsList.innerHTML = html;
      searchSuggestions.style.display = 'block';

      // Add click handlers to new suggestions
      suggestionsList.querySelectorAll('.suggestion-item').forEach(item => {
        item.addEventListener('click', (e) => {
          const suggestionQuery = e.currentTarget.getAttribute('data-query');
          searchInput.value = suggestionQuery;
          searchInput.focus();
          performSearch(suggestionQuery);
        });
      });
    }

    // Perform predictive search
    function performSearch(query) {
      currentSearchQuery = query;

      fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last&section_id=predictive-search`)
        .then(response => response.json())
        .then(data => {
          displayResults(data, query);
        })
        .catch(error => {
          console.error('Search error:', error);
          loadingElement.style.display = 'none';
          searchSuggestions.style.display = 'none';
          predictiveContent.style.display = 'block';
          predictiveContent.innerHTML = '<div class="no-results"><p>An error occurred. Please try again.</p></div>';
        });
    }

    // Display search results
    function displayResults(data, query) {
      loadingElement.style.display = 'none';
      predictiveContent.style.display = 'block';

      const products = data.resources.results.products || [];

      if (products.length === 0) {
        searchSuggestions.style.display = 'none';
        predictiveContent.innerHTML = `
          <div class="no-results">
            <p>No products found for "${query}"</p>
          </div>
        `;
        return;
      }

      let html = `
        <div class="search-results-header">
          <h3 class="search-results-title">Products</h3>
          <span class="search-results-count">${products.length} ${products.length === 1 ? 'result' : 'results'}</span>
        </div>
        <div class="predictive-search-grid">
      `;

      products.forEach(product => {
  // price_min = jo price hum card par dikha rahe hain (cheapest variant)
  const priceValue   = parseFloat(product.price_min || product.price);
  // USI variant range ka compare_at use karein — _max doosre variant ka hota hai
  const compareValue = parseFloat(product.compare_at_price_min);

  const price = formatMoney(priceValue);

  let discountBadgeHtml = '';
  let comparePrice = '';

  if (Number.isFinite(compareValue) && compareValue > priceValue) {
    const discountPercent = Math.round(((compareValue - priceValue) / compareValue) * 100);
    discountBadgeHtml = `
      <span class="badge-pad-s">
        <span class="badge-s">${discountPercent}% OFF</span>
      </span>
    `;
    comparePrice = formatMoney(compareValue);
  }
  const image = product.featured_image ? product.featured_image.url : '';

  html += `
    <a href="${product.url}" class="predictive-product-card">
      <div class="predictive-product-image">
        ${image ? `<img src="${image}" alt="${product.title}" loading="lazy">` : ''}
        ${discountBadgeHtml} 
      </div>
      <h4 class="predictive-product-title">${product.title}</h4>
      <div class="review-stars-prd">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="#d84a72">
                <polygon points="12,2 15,9 22,9 17,14 19,21 12,17 5,21 7,14 2,9 9,9"></polygon>
              </svg>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="#d84a72">
                <polygon points="12,2 15,9 22,9 17,14 19,21 12,17 5,21 7,14 2,9 9,9"></polygon>
              </svg>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="#d84a72">
                <polygon points="12,2 15,9 22,9 17,14 19,21 12,17 5,21 7,14 2,9 9,9"></polygon>
              </svg>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="#d84a72">
                <polygon points="12,2 15,9 22,9 17,14 19,21 12,17 5,21 7,14 2,9 9,9"></polygon>
              </svg>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="#d84a72">
                <polygon points="12,2 15,9 22,9 17,14 19,21 12,17 5,21 7,14 2,9 9,9"></polygon>
              </svg>
            </div>
      <div class="predictive-product-price">
        ${price}
        ${comparePrice ? `<span class="compare-price">${comparePrice}</span>` : ''}
      </div>
    </a>
  `;
});

      html += `
        </div>
        <a href="/search?q=${encodeURIComponent(query)}&type=product" class="view-all-results">
          View All Results
        </a>
      `;

      predictiveContent.innerHTML = html;
    }

    // Format money in PKR - NO DIVISION, just remove decimals
    function formatMoney(cents) {
      // Price is already in full amount, just remove decimals
      const price = Math.round(cents);
      return `Rs. ${Number(price).toLocaleString('en-PK')}`;
    }

    // Close search results when clicking outside (only for this instance)
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.animated-search-container') || e.target.closest('.animated-search-wrapper') !== wrapper) {
        predictiveResults.style.display = 'none';
      }
    });

    // Prevent search results from closing when clicking inside
    predictiveResults.addEventListener('click', (e) => {
      e.stopPropagation();
    });
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSearchInstances);
  } else {
    initializeSearchInstances();
  }

  // INP FIX: removed the body-wide MutationObserver.
  // The search bar is rendered by Liquid, so it already exists on page load.
})();